<template>
    <div>
        <table class="table">
            <tbody>
            <app-list-konto-item v-for="item in element.transactions" :key="item.id"
                                 :id="id"
                                 :name="item.name"
                                 :date="element.dateFrom"
                                 :trans="item.transactionAmount"
                                 :isTrans="true"
            ></app-list-konto-item>
            </tbody>
        </table>
    </div>
</template>

<script>
  import ListKontoItem from './ListKontoItem'
  import data from '../../data/konto'

  export default {
    props: ['transID'],
    data () {
      return {
        id: this.$route.params.transID,
        element: data.find(el => el.id === this.$route.params.transID)
      }
    },
    components: {
      appListKontoItem: ListKontoItem
    }
  }
</script>

<style lang="scss" scoped>
    @import '../../styles/app';
</style>

